import { jsx, jsxs } from "react/jsx-runtime";
import { ChatBubble } from "@pcln/horizon";
import { Button, ChatMessage, Flex, Text } from "pcln-design-system";
import { useContext } from "react";
import MessageFooter from "./components/MessageFooter/MessageFooter.js";
import { ChatbotDataContext } from "./context/ChatbotDataContext.js";
import { TravelBotLogoImage } from "./TravelBotLogoImage.js";
function SignInMarkerComponent(props) {
    const { signedIn, onSigninClick } = props;
    const { setiValues } = useContext(ChatbotDataContext);
    const onClickHandler = ()=>{
        window.PCLN?.pclnEventDispatcher?.dispatch('GLOBAL_PCLN_LAUNCH_SIGNIN_MODAL');
    };
    const content = signedIn ? /*#__PURE__*/ jsx(Text, {
        mb: 3,
        fontSize: 2,
        children: "Looks like you're already signed in! You're welcome to ask additional questions if you have any!"
    }) : /*#__PURE__*/ jsxs(Flex, {
        flexDirection: "column",
        children: [
            /*#__PURE__*/ jsx(Text, {
                mb: 3,
                fontSize: 2,
                children: "Click the button below to Sign In."
            }),
            /*#__PURE__*/ jsx(Text, {
                fontSize: 2,
                children: "To safeguard your privacy, this chat will be cleared upon signing in."
            })
        ]
    });
    return /*#__PURE__*/ jsxs(Flex, {
        mb: 3,
        flexDirection: "column",
        children: [
            setiValues?.shouldEnablePortalUpdates ? /*#__PURE__*/ jsx(ChatBubble, {
                role: "response",
                showResponseIcon: true,
                children: content
            }) : /*#__PURE__*/ jsx(ChatMessage, {
                variation: "initial",
                Icon: TravelBotLogoImage,
                footer: /*#__PURE__*/ jsx(MessageFooter, {}),
                message: content
            }),
            !signedIn && /*#__PURE__*/ jsx(Flex, {
                ml: 3,
                mt: 3,
                children: /*#__PURE__*/ jsx(Button, {
                    variation: "subtle",
                    onClick: onSigninClick || onClickHandler,
                    children: "Sign In"
                })
            })
        ]
    });
}
export { SignInMarkerComponent };
